enum FacilityReportStatus {
    InProgress,
    Ready,
    Error,
}

export { FacilityReportStatus }
